/**
 * @generated SignedSource<<07def6d5d9356144983662ed1e9b9ea2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterOperator = "BEGINS_WITH" | "CONTAINS" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "NEQ" | "NOT_CONTAINS" | "%future added value";
export type OrderByDirection = "ASC" | "DESC" | "%future added value";
export type DrawingSetAnnotationListInput = {
  filter?: DrawingSetAnnotationListFilter | null | undefined;
  orderBy?: DrawingSetAnnotationListOrder | null | undefined;
};
export type DrawingSetAnnotationListFilter = {
  createdAt?: Filter | null | undefined;
  createdById?: Filter | null | undefined;
  drawingSetId?: Filter | null | undefined;
  drawingSheetId?: Filter | null | undefined;
};
export type Filter = {
  operator: FilterOperator;
  value: string;
};
export type DrawingSetAnnotationListOrder = {
  createdAt?: OrderByDirection | null | undefined;
  updatedAt?: OrderByDirection | null | undefined;
};
export type getDrawingSetAnnotationListQuery$variables = {
  first?: number | null | undefined;
  input: DrawingSetAnnotationListInput;
};
export type getDrawingSetAnnotationListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"drawingSetAnnotationListFragment">;
};
export type getDrawingSetAnnotationListQuery = {
  response: getDrawingSetAnnotationListQuery$data;
  variables: getDrawingSetAnnotationListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "getDrawingSetAnnotationListQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "drawingSetAnnotationListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "getDrawingSetAnnotationListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DrawingSetAnnotationConnection",
        "kind": "LinkedField",
        "name": "drawingSetAnnotationList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DrawingSetAnnotationEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DrawingSetAnnotation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "xfdf",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdById",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "drawingSetId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "drawingSheetId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "input"
        ],
        "handle": "connection",
        "key": "drawingSetAnnotationListFragment___drawingSetAnnotationList",
        "kind": "LinkedHandle",
        "name": "drawingSetAnnotationList"
      }
    ]
  },
  "params": {
    "cacheID": "a87763dd1d2f9f955570b66acb43dbc0",
    "id": null,
    "metadata": {},
    "name": "getDrawingSetAnnotationListQuery",
    "operationKind": "query",
    "text": "query getDrawingSetAnnotationListQuery(\n  $input: DrawingSetAnnotationListInput!\n  $first: Int\n) {\n  ...drawingSetAnnotationListFragment_1oNFuy\n}\n\nfragment drawingSetAnnotationConnectionFragment on DrawingSetAnnotationConnection {\n  edges {\n    cursor\n    node {\n      ...drawingSetAnnotationFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageInfoFragment\n  }\n}\n\nfragment drawingSetAnnotationFragment on DrawingSetAnnotation {\n  id\n  createdAt\n  updatedAt\n  createdById\n  drawingSetId\n  drawingSheetId\n  type\n  xfdf\n}\n\nfragment drawingSetAnnotationListFragment_1oNFuy on Query {\n  drawingSetAnnotationList(input: $input, first: $first) {\n    edges {\n      cursor\n      node {\n        id\n        xfdf\n        ...drawingSetAnnotationFragment\n        __typename\n      }\n    }\n    ...drawingSetAnnotationConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageInfoFragment on PageInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n}\n"
  }
};
})();

(node as any).hash = "574e5d0ee1d28fb745658f1dce2d4f5d";

export default node;
